export function createOrganizationHierarchyClient(transport) {
    return {
        /**
         * Create a tenant organization unit
         *
         * Requires scope: organization:write
         */
        postTenantsOrganizationUnits(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/organization-units`,
                body,
                options,
            });
        },
        /**
         * Get a tenant organization unit
         *
         * Requires scope: organization:read
         */
        getTenantsOrganizationUnits(tenantId, unitId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/organization-units/${encodeURIComponent(unitId)}`,
                options,
            });
        },
        /**
         * Revise a unit with optimistic concurrency
         *
         * Requires scope: organization:write
         */
        putTenantsOrganizationUnits(tenantId, unitId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/organization-units/${encodeURIComponent(unitId)}`,
                body,
                options,
            });
        },
        /**
         * List where customers can book with this tenant
         *
         * Requires scope: booking-channel:read
         */
        listBookingChannels(tenantId, limit, afterType, afterChannelId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/booking-channels`,
                query: { limit: limit, afterType: afterType, afterChannelId: afterChannelId },
                options,
            });
        },
        /**
         * Open a way for customers to book
         *
         * Requires scope: booking-channel:write
         */
        addBookingChannel(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/booking-channels`,
                body,
                options,
            });
        },
        /**
         * Pause a channel, bring it back, or rename it
         *
         * Requires scope: booking-channel:write
         */
        reviseBookingChannel(tenantId, channelId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/booking-channels/${encodeURIComponent(channelId)}`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=organization-hierarchy.js.map